import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ColumnComponent } from '../column.component';

@Component({
  selector: 'app-column-lineage',
  templateUrl: './column-lineage.component.html',
  styleUrl: './column-lineage.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ColumnLineageComponent extends ColumnComponent {}
